<p-toggleswitch
  class="inline-flex"
  [style]="$style"
  [styleClass]="switchClasses()"
  [(ngModel)]="value"
  (ngModelChange)="handleValueChange($event)"
  [name]="name()"
  [tabindex]="tabindex"
  [ariaLabel]="ariaLabel"
  [ariaLabelledBy]="ariaLabelledBy"
  [disabled]="disabled() || disabledState()"
  [trueValue]="trueValue"
  [falseValue]="falseValue"
  [readonly]="readonly"
  (onChange)="onChange.emit($event); onToggle()?.($event)"
  [inputId]="inputId">
  <ng-template #handle let-checked="checked">
    <span
      class="switch-indicator"
      [class.switch-indicator--small]="switchSize() === 'sm'">
    </span>
  </ng-template>
</p-toggleswitch>
